import { IconButton, List, ListItemButton, ListItemText, Typography } from "@mui/material";
import { useGet, useRest } from "react-common";
import { useTranslation } from 'react-i18next';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import '../styles/SlideshowsList.css';
import { useNavigate } from "react-router-dom";

const SlideshowsList = ({activeSlideshowID, setActiveSlideshowID}) => {

    const { t } = useTranslation();
    const { postData } = useRest();
    const navigate = useNavigate();
    const [presentations = []] = useGet("Slideshows", {
        transform: (res) => {
            return res.records || [];
        }
    });
    const createPresentation = (slideshowID) => {
        postData('Presentation', { slideshowID: slideshowID })
            .then((newID) => navigate(`/presentation/${newID}/presenter`))
    }  
    return (
        <div className="presentationList">
            <Typography style={{ padding: 10 }} variant="h6">{t("myPresentations")}</Typography>
            {!presentations.length ?
                (<div>{t("presentationAccess")}</div>)
                : <List>{presentations.map((slideshow) =>
                    (<div className="listItem" key={slideshow.id}>
                        <ListItemButton
                            selected={slideshow.id === activeSlideshowID} 
                            key={slideshow.id}
                            onClick={() => setActiveSlideshowID(slideshow.id)}
                        >
                            <ListItemText primary={slideshow.title}/>
                            <IconButton size="small" onClick={() => createPresentation(slideshow.id)}>
                                    <PlayArrowIcon color="action" fontSize="small"/>    
                            </IconButton>     
                        </ListItemButton>
                         
                    </div>
                    ))
                }
                </List>
            }    
        </div>   
    )
}

export default SlideshowsList;